// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEditCalendar_root__14_ds"};